import React from 'react';

function typeBadge(t) {
  if (!t) return 'secondary';
  if (t.startsWith('buy')) return 'success';
  if (t.startsWith('sell')) return 'danger';
  return 'secondary';
}

export default function PendingOrdersTable({ orders = [], showTrader = false }) {
  if (!orders.length) {
    return <p className="text-muted text-center py-4">No pending orders.</p>;
  }

  return (
    <div className="table-responsive table-cards table-cards-wrap">
      <table className="table">
        <thead>
          <tr>
            <th>Ticket</th>
            {showTrader && <th>Trader</th>}
            <th>Symbol</th>
            <th>Type</th>
            <th className="num">Lots</th>
            <th className="num">Pending Price</th>
            <th className="num">Stop-Limit</th>
            <th className="num">SL</th>
            <th className="num">TP</th>
            <th>Placed</th>
          </tr>
        </thead>
        <tbody>
          {orders.map(o => {
            // Two shapes: trader-side Trade row, or copier-side CopyExecution
            // with originalTradeId populated.
            const trade = o.originalTradeId || o;
            const key   = o._id || trade._id || trade.ticket;
            const ticket = o.copierTicket || trade.ticket;
            return (
              <tr key={key}>
                <td data-label="Ticket" className="num">{ticket}</td>
                {showTrader && <td data-label="Trader" className="small">{o.traderId?.email || '—'}</td>}
                <td data-label="Symbol"><strong>{trade.symbol}</strong></td>
                <td data-label="Type">
                  <span className={`badge badge-${typeBadge(trade.type)}`}>
                    {trade.type?.replace(/_/g, ' ').toUpperCase()}
                  </span>
                </td>
                <td data-label="Lots" className="num">{o.scaledLots ?? trade.lots}</td>
                <td data-label="Pending Price" className="num">{trade.pendingPrice?.toFixed(5) ?? '—'}</td>
                <td data-label="Stop-Limit" className="num">{trade.stoplimitPrice > 0 ? trade.stoplimitPrice.toFixed(5) : '—'}</td>
                <td data-label="SL" className="num">{trade.sl > 0 ? trade.sl.toFixed(5) : '—'}</td>
                <td data-label="TP" className="num">{trade.tp > 0 ? trade.tp.toFixed(5) : '—'}</td>
                <td data-label="Placed" className="text-muted small">
                  {trade.openTime ? new Date(trade.openTime).toLocaleString() : '—'}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
